/*
 *
 * OnDemandSettlements constants
 *
 */

import { SETTLE_NOW_SUCCESS, SETTLE_NOW_ERROR } from 'utils/constants';

const BASE_ACTION_CONSTANT = 'app/OnDemandSettlements';

export const DEFAULT_ACTION = 'app/OnDemandSettlements/DEFAULT_ACTION';

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const SEARCH_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/SEARCH_SETTLEMENTS`;

export const SAVE_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/SAVE_SETTLEMENTS`;

export const GET_ON_DEMAND_SETTLEMENT_STATUS = `${BASE_ACTION_CONSTANT}/GET_ON_DEMAND_SETTLEMENT_STATUS`;

export const GET_SETTLEMENT_RATES = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_RATES`;

export const GET_ON_DEMAND_MAX_DAILY_LIMIT = `${BASE_ACTION_CONSTANT}/GET_ON_DEMAND_MAX_DAILY_LIMIT`;

export const GET_UNSETTLED_AMOUNT = `${BASE_ACTION_CONSTANT}/GET_UNSETTLED_AMOUNT`;

export const UPDATE_UNSETTLED_AMOUNT = `${BASE_ACTION_CONSTANT}/UPDATE_UNSETTLED_AMOUNT`;

export const REQUEST_ON_DEMAND_ACTIVATION = `${BASE_ACTION_CONSTANT}/REQUEST_ON_DEMAND_ACTIVATION`;

export const CREATE_ON_DEMAND_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/CREATE_ON_DEMAND_SETTLEMENTS`;

export const GET_ELIGIBLE_FUNDS = `${BASE_ACTION_CONSTANT}/GET_ELIGIBLE_FUNDS`;

export const UPDATE_ELIGIBLE_FUNDS = `${BASE_ACTION_CONSTANT}/UPDATE_ELIGIBLE_FUNDS`;

export const GET_SETTLEMENT_HOLIDAYS = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_HOLIDAYS`;

export const UPDATE_SETTLEMENT_HOLIDAYS = `${BASE_ACTION_CONSTANT}/UPDATE_SETTLEMENT_HOLIDAYS`;

// ODS Free Trial

export const GET_FREE_TRIAL_STATUS = `${BASE_ACTION_CONSTANT}/GET_FREE_TRIAL_STATUS`;

export const UPDATE_FREE_TRIAL_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_FREE_TRIAL_STATUS`;

export const EXTEND_FREE_TRIAL = `${BASE_ACTION_CONSTANT}/EXTEND_FREE_TRIAL`;

export const GET_FREE_TRIAL_NUDGE = `${BASE_ACTION_CONSTANT}/GET_FREE_TRIAL_NUDGE`;

// ODS Free Trial

export const ON_DEMAND_GST_VALUE = 18;

export const ACTIVE = 'ACTIVE';

export const DISABLED = 'DISABLED';

export const IN_REVIEW = 'IN_REVIEW';

export const REJECTED = 'REJECTED';

export const NOT_REQUESTED = 'NOT_REQUESTED';

export const INCREASE_LIMIT = 'INCREASE_LIMIT';

export const INCREASE_LIMIT_SUCCESS = 'INCREASE_LIMIT_SUCCESS';

export const ON_DEMAND_LIMIT = 'ON_DEMAND_LIMIT';

export const UNSETTLED_AMOUNT = 'UNSETTLED_AMOUNT';

export const GET_ON_DEMAND_SETTLE_NOW_DATA = `${BASE_ACTION_CONSTANT}/GET_ON_DEMAND_SETTLE_NOW_DATA`;

export const GET_FREE_TRIAL_CONSTANTS = `${BASE_ACTION_CONSTANT}/GET_FREE_TRIAL_CONSTANTS`;

export const GET_ON_DEMAND_SETTLE_NOW_DATA_URL = {
  url: '/pg/ondemand/charges',
  method: 'GET',
};

export const SOFT_APPROVED = 'SOFT_APPROVED';

export const ON_DEMAND_SETTLEMENT_STATUS_MAPPER = {
  ACTIVE,
  IN_REVIEW,
  REJECTED,
  DISABLED,
  RISK_APPROVED: IN_REVIEW,
  FINANCE_APPROVED: IN_REVIEW,
};

export const FREE_TRIAL_MAX_AMOUNT_LIMIT = 2000;

export const KNOW_MORE_URL =
  'https://www.cashfree.com/docs/payments/split/vendor/dashboard/settlements#on-demand-settlement';

export const GET_ON_DEMAND_MAX_DAILY_LIMIT_URL = {
  url: '/pg/ondemand/dailylimit',
  method: 'GET',
};

export const GET_ON_DEMAND_CONSTANTS_URL = {
  url: '/pg/ondemand/constants',
  method: 'GET',
};

export const SETTLE_NOW_STATUS_MAPPER = {
  [SETTLE_NOW_SUCCESS]: {
    type: 'success',
    title: 'Settlement Initiated Successfully',
    description: 'You will receive the settlement within 1-3 hrs.',
    content: {
      initiatedAt: 'Initiated At',
      settlementId: 'Settlement ID',
      deductedAmount: 'Deducted Amt.',
      additionalCharges: 'Addl. Charges',
      settledAmount: 'Settled Amt.',
    },
  },
  [SETTLE_NOW_ERROR]: {
    type: 'danger',
    title: 'Settlement Initiation Failed',
    description: '',
    content: {
      initiatedAt: 'Initiated At',
      settlementId: 'Settlement ID',
      settledAmount: 'Requested Withdrawal Amt.',
    },
  },
};

export const MINIMUM_ELIGIBLE_AMOUNT = 1000;

export const ON_DEMAND_TEST_MID = 106951;

export const ON_DEMAND_TEST_MINIMUM_ELIGIBLE_AMOUNT = 5;

export const HEADINGS = [
  {
    key: 'initiatedAt',
    displayName: 'Initiated At',
    width: 0.1,
  },
  {
    key: 'settlementId',
    displayName: 'Settlement ID',
    width: 0.08,
  },
  {
    key: 'utr',
    displayName: 'UTR No.',
    width: 0.08,
  },
  {
    key: 'deductedAmount',
    displayName: 'Deducted Amt.',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'additionalCharges',
    displayName: 'Addl. Charges',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'settlementAmount',
    displayName: 'Settled Amt.',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'status',
    displayName: 'Status',
    width: 0.07,
  },
  // commenting for now since api is not returning this
  // {
  //   key: 'settlementLinkCTA',
  //   displayName: '',
  //   width: 0.03,
  // },
];

export const SEARCH_SETTLEMENTS_STANDARD_URL = {
  url: '/pg/settlements/merchant-payments/search',
  method: 'GET',
};

export const SEARCH_SETTLEMENTS_INSTANT_URL = {
  url: '/pg/settlements/instant/search',
  method: 'GET',
};

export const GENERATE_VENDOR_SETTLEMENTS_REPORTS_URL = {
  url: '/common/report/vendor-settlement/$payment_id$',
  method: 'GET',
};

export const GENERATE_VENDOR_SETTLEMENTS_REPORTS_URL_V2 = {
  url: '/pg/report/vendor-settlement/$payment_id$',
  method: 'GET',
};

export const SEARCH_ON_DEMAND_SETTLEMENTS_URL = {
  url: '/pg/settlements/ondemand/search',
  method: 'GET',
};

export const CREATE_ON_DEMAND_SETTLEMENTS_URL = {
  url: '/pg/ondemand/create',
  method: 'POST',
};

export const GET_ELIGIBLE_FUNDS_URL = {
  url: '/pg/ondemand/eligible-funds',
  method: 'GET',
};

export const GET_SETTLEMENT_RATES_URL = {
  url: '/pg/settlements/instant/rates',
  method: 'GET',
};

export const GET_ON_DEMAND_SETTLEMENT_STATUS_URL = {
  url: '/pg/ondemand/status',
  method: 'GET',
};

export const ACTIVATION_MODAL = 'ACTIVATION_MODAL';
